import { getObjects, createObject, updateObject, deleteObject, exportObjects, uploadParams, exportFile_Bilan } from "../../../services/services";
import Conditions from "../../../assets/files/conditions.json";

const combboxElements = [
  { label: "Element A 1001", value: 1 },
  { label: "Element B 1002", value: 2 },
];


const HFI_LFI_OPTIONS = [
  { label: "HFI", value: "HFI" },
  { label: "LFI", value: "LFI" },
];

const Identity_OPTIONS = [
  { label: "Functional", value: "Functional" },
  { label: "Integration", value: "Integration" },
];

export const paramsConfig = {
  title: "Parameters",
  entityLabel: "Parameter",

  idField: "id",

  rowActions: [
    { key: "info", label: "Info", permission: "view_pbsElements", action: "info" },
    { key: "edit", label: "Edit", permission: "edit_pbsElements", action: "edit" },
    { key: "delete", label: "Delete", permission: "delete_pbsElements", action: "delete" }
  ],

  columnActions: [
    { key: "element_id", label: "Parent", permission: "view_pbsElements", action: "goToElements" },
  
  ],

  actionHandlers: {
    info: ({ entity, setState, setFormParams }) => {
    setState("info");
    setFormParams([entity]);
    },
    edit: ({ entity, setState, setFormParams }) => {
      setState("edit");
      setFormParams([entity]);
    },
    delete: async ({ entity, setEntityToDelete }) => {
      setEntityToDelete(entity);
    },
    goToElements: ({ entity, navigate }) => {
      localStorage.setItem(
        "filters_Elements",
        JSON.stringify([{"attribute":"id","condition":"==","value":entity.element_id,"type":"int"}])
      );
      navigate(`/Elements/1`);
    },
  },
  services: {
    list: getObjects,
    create: createObject,
    update: updateObject,
    delete: deleteObject,
    export: exportObjects,
    export_bilan : exportFile_Bilan,
    upload: uploadParams,
    filters: "show",
    columns: "show",

    services_url_names: {
    list: "getParams",
    create: "createParam",
    update: "updateParam",
    delete: "deleteParam",
    export: "exportParameters",
    export_bilan: "exportParameters_Bilan",
    upload: "uploadParams"
    },
  },

  attributes: [
    { label: "id", value: "id", type: "int", is_default:"true" },
    { label: "element_id", value: "element_id", type: "int", is_default:"true" },
    { label: "element__pbscode", value: "element__pbscode", type: "str" },
    { label: "paramValue", value: "paramValue", type: "float" },
    { label: "paramUnit", value: "paramUnit", type: "str" },
    { label: "paramMargin", value: "paramMargin", type: "float" },
    { label: "paramType", value: "paramType", type: "str" },
    { label: "description", value: "description", type: "str" },
    { label: "ref", value: "ref", "type": "str" },
    { label: "comment", value: "comment", type: "str" },
    { label: "flag", value: "flag", type: "str", is_default:"true" },
    { label: "identity", value: "identity", type: "str" },
    { label: "impact_or_zaxis", value: "impact_or_zaxis", type: "str" },
    { label: "author", value: "author", type: "str", is_default:"true" },
    { label: "verified_by", value: "verified_by", type: "str", is_default:"true" },
    { label: "created_at", value: "created_at", type: "date" },
    { label: "updated_at", value: "updated_at", type: "date" }, 
    
],
  conditions: Conditions,

  formFields: [
    { key: 'element_id', label: 'element_id', type: 'Autocomplete', Autocomplete:combboxElements, placeholder:'Select PBS element', validation: 'required' },
    { key: 'flag', label: 'flag', type: 'select', SELECT_OPTIONS:HFI_LFI_OPTIONS, validation: 'required' },
    { key: 'author', label: 'author', type: 'input', validation: ['required'], placeholder:'author' },
    { key: 'verified_by', label: 'verified_by', type: 'input', placeholder:'verified_by', validation: 'required' },
    
    { key: 'paramName', label: 'paramName', type: 'input',  validation: 'required'},
    { key: 'paramValue', label: 'paramValue', type: 'input' },
    { key: 'paramUnit', label: 'paramUnit', type: 'input' },
    { key: 'paramMargin', label: 'paramMargin', type: 'input' },
    { key: 'paramType', label: 'paramType', type: 'input' },
    { key: 'description', label: 'description', type: 'input' },
    { key: 'ref', label: 'ref', type: 'input' },
    { key: 'comment', label: 'comment', type: 'input' },
    { key: 'identity', label: 'identity', type: 'select', SELECT_OPTIONS:Identity_OPTIONS },
    { key: 'impact_or_zaxis', label: 'impact_or_zaxis', type: 'input' },
  ],

   defaultFilters : [],

  // =========================
  // TABS CONFIG (CUSTOM PER ENTITY)
  // =========================
  tabs: [
    {
      label: "All",
      filters: [],   // tabIndex 0
    },
    {
      label: "SUM NAME POWER",
      filters: [],//[{attribute:'paramName',condition:'in',value:'Power',type:'str'}],   // tabIndex 1
    },
  ],
};
